import React from "react";
import FeasibilityBot from "./feasibilityBot";
import ContactBand, { FactsRow } from "./contactBand";
import { githubUrl, projectInquiryUrl } from "../lib/contact";
import "./about.css";

const About = () => {
  const steps = [
    {
      title: "Scope & prototype",
      text: "Agree on the core flow, the platform, and what launch means. Early prototypes settle decisions before they get expensive.",
    },
    {
      title: "Build & iterate",
      text: "Frequent TestFlight or preview builds, so you use the app while it's being made — not only at the end.",
    },
    {
      title: "Ship & hand off",
      text: "App Store release, crash monitoring, and clean, documented code your team can own.",
    },
  ];

  const timeline = [
    {
      year: "2014–now",
      title: "Professional mobile development",
      text: "Complex production apps — native iOS (SwiftUI) and cross-platform (React Native, Expo, Flutter, KMP), with backends on Cloudflare, Supabase, and Firebase.",
    },
    {
      year: "2026",
      title: "One More Street",
      text: "A walking app whose map fills in as you go, with stamps and city stamp books. SwiftUI and MapLibre on the phone, Cloudflare Workers and Durable Objects behind it, maps built from OpenStreetMap.",
    },
    {
      year: "2026",
      title: "Slipsee",
      text: "Receipt scanning, spending insights, and questions answered from your receipts. Built with SwiftUI and Cloudflare Workers, now on the App Store.",
    },
    {
      year: "2026",
      title: "Mood Recall",
      text: "Private journaling, semantic search, SQLite, FAISS, Core ML.",
    },
    {
      year: "2025",
      title: "Nihongo Easy · Calories AI",
      text: "Adaptive language drills, Expo workflows, AI-assisted mobile features.",
    },
    {
      year: "2024",
      title: "JuicyPomo",
      text: "Minimalist SwiftUI timer — speed, restraint, App Store polish.",
    },
    {
      year: "2019–20",
      title: "Automation and UI experiments",
      text: "iBooks→Anki automation, Flutter streaming UI, retro component systems.",
    },
  ];

  return (
    <main className="about-page">
      <section className="about-hero">
        <figure className="about-portrait">
          <img src="/images/avatar-professional.png" alt="Weizhi" />
        </figure>

        <div className="about-copy">
          <h1>I'm Weizhi. I've been building mobile apps since 2014.</h1>
          <p>
            I'm a native and cross-platform app developer based in Tokyo. I've
            spent my career building complex production mobile apps, and I
            still care about the small details that make software feel fast,
            clear, and pleasant. Outside client work I ship my own apps —
            walking maps, receipt tracking, private journals, focused
            learning tools.
          </p>
          <FactsRow />
          <div className="about-actions">
            <a
              className="button-link"
              href={projectInquiryUrl}
            >
              Tell me about your app
            </a>
            <a
              className="button-link secondary"
              href={githubUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>
            <FeasibilityBot />
          </div>
        </div>
      </section>

      <section className="process-section" aria-labelledby="process-title">
        <div className="rule-head">
          <span className="rule-idx">01</span>
          <h2 id="process-title">How I work</h2>
          <p>From first call to App Store release.</p>
        </div>
        <ol className="caps-strip" aria-labelledby="process-title">
          {steps.map((item, index) => (
            <li className="cap-cell" key={item.title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </li>
          ))}
        </ol>
      </section>

      <section className="experience-section" aria-labelledby="experience-title">
        <div className="rule-head">
          <span className="rule-idx">02</span>
          <h2 id="experience-title">What I have been building</h2>
        </div>
        <ol className="timeline">
          {timeline.map((item) => (
            <li key={`${item.year}-${item.title}`}>
              <time>{item.year}</time>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </li>
          ))}
        </ol>
      </section>

      <ContactBand />
    </main>
  );
};

export default About;
